export default __webpack_public_path__ + "static/media/mmapp.4bc11b03.jpg";